import { createContext } from 'react'
import { ProductCategory } from '@leid/api-products'

const CategoriesContext = createContext<{ isLoading: boolean; categories: ProductCategory[] }>({
  isLoading: true,
  categories: [],
})

export default CategoriesContext
